import {Mapper} from '@s-ui/domain'

export default class OrderRawDataToOrderEntityMapper extends Mapper {
  constructor({
    entity,
    productsToVisibilityProductsListVOMapper,
    priceRawDataToPriceVOMapper,
    taxRawDataToTaxVOMapper
  }) {
    super()
    this._entity = entity
    this._productsToVisibilityProductsListVOMapper = productsToVisibilityProductsListVOMapper
    this._priceRawDataToPriceVOMapper = priceRawDataToPriceVOMapper
    this._taxRawDataToTaxVOMapper = taxRawDataToTaxVOMapper
  }

  map = ({orderId, price, tax: taxRawdata, products: productsRawData}) => {
    const productsVO = this._productsToVisibilityProductsListVOMapper.map({
      productsList: productsRawData
    })

    const priceVO = this._priceRawDataToPriceVOMapper.map({price})

    const tax = this._taxRawDataToTaxVOMapper.map({tax: taxRawdata}).getTax()

    const amount = tax.amountLabelValue
    const {percentage, type} = tax

    const products = productsVO.getProducts().reduce((acc, value, index) => {
      const {
        name,
        title,
        price: {amountLabelValue}
      } = value.getProduct()
      acc[index] = {
        name,
        title,
        price: amountLabelValue
      }
      return acc
    }, [])

    return this._entity({
      id: orderId,
      amount: priceVO.getPrice(),
      tax: {amount, percentage, type},
      products
    })
  }
}
